import SplitButtonBase, {
  SplitButtonOptionProps,
  SplitButtonProps,
} from './SplitButton';
import SplitButtonBaseMui, {
  SplitButtonOptionPropsMui,
  SplitButtonPropsMui,
} from './SplitButtonMui';

export type { SplitButtonOptionProps, SplitButtonProps };
export type { SplitButtonOptionPropsMui, SplitButtonPropsMui };
export const SplitButton = SplitButtonBase;
export const SplitButtonMui = SplitButtonBaseMui;
